import { UserActivityDetails } from '@/models/user-activity/user-activity-details';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-user-activity-log',
  templateUrl: './user-activity-log.component.html',
  styleUrl: './user-activity-log.component.scss'
})
export class UserActivityLogComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();

  totalSaleAmount: number = 0;

  fromDate!: string;
  toDate!: string;
  todayMax!: string;

  startDate: number = 0;
  endDate: number = 0;

  getUserActivityDetails: UserActivityDetails[] = [];

  currentFilterDetails: UserActivityDetails[] = [];

  searchText: string = '';

  selectedUserType: string = '';

  constructor(
    private appService: AppService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.todayMax = this.formatDate(new Date());

    this.setLastWeekDates();

    this.getActivityDetailsByStartAndEndDate();
  }

  // last 7 days
  setLastWeekDates() {

    const today = new Date();

    const lastWeek = new Date();

    lastWeek.setDate(today.getDate() - 7);

    this.fromDate = this.formatDate(lastWeek);

    this.toDate = this.formatDate(today);

    this.convertToEpoch();
  }

  // yyyy-MM-dd
  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  // convert to epoch
  convertToEpoch() {

    this.startDate = new Date(this.fromDate).getTime();

    this.endDate = new Date(this.toDate).getTime();
  }

  // date change
  onDate() {

    if (!this.fromDate || !this.toDate) return;

    if (new Date(this.fromDate) > new Date(this.toDate)) {

      this.toastr.error('From Date should not be greater than To Date');

      return;
    }

    this.convertToEpoch();

    this.getActivityDetailsByStartAndEndDate();
  }

  // API call
  getActivityDetailsByStartAndEndDate() {

    this.spinner.show();

    this.appService
      .getActivityDetailsByStartAndEndDate(this.startDate, this.endDate)
      .subscribe({

        next: (res) => {

          this.spinner.hide();

          this.getUserActivityDetails = res.sort(
            (a, b) => b.userTrackingSeq - a.userTrackingSeq
          );

          this.applyFilters();
        },

        error: (err) => {

          this.spinner.hide();

          this.toastr.error('Failed to load activity data');

          console.error(err);
        }
      });
  }

  // filter method
  applyFilters() {

    let filtered = [...this.getUserActivityDetails];

    // user type filter
    if (this.selectedUserType) {

      filtered = filtered.filter(
        item => item.userType === this.selectedUserType
      );
    }

    // search filter
    if (this.searchText?.trim()) {

      const search = this.searchText.toLowerCase();

      filtered = filtered.filter(item =>

        (item.name || '').toLowerCase().includes(search) ||

        (item.action || '').toLowerCase().includes(search) ||

        (item.screenName || '').toLowerCase().includes(search) ||

        (item.description || '').toLowerCase().includes(search) ||

        (item.userType || '').toLowerCase().includes(search)
      );
    }

    this.currentFilterDetails = filtered;
  }
}
